window.addEventListener('load', () => {
    document.querySelectorAll('[data-image-ticker]').forEach((ticker) => {
        const images = ticker.querySelectorAll('IMG');
        const pixelsPerSecond = parseInt(ticker.getAttribute('data-image-ticker'));

        let imagesLoadedLength = 0;
        const onSlideScrollImageLoad = () => {
            imagesLoadedLength++;
            if (images.length === imagesLoadedLength) {
                ticker.style.animation = "image-ticker-motion " + (ticker.offsetWidth / pixelsPerSecond) + "s linear infinite";
                ticker.addEventListener('mouseenter',  () => {
                    //ticker.style.animationPlayState = 'paused';
                });
                ticker.addEventListener('mouseleave',  () => {
                    //ticker.style.animationPlayState = 'running';
                });
            }
        };
        images.forEach((image) => {
            image.onload = onSlideScrollImageLoad;
            image.src = image.getAttribute('data-src');
        });
    });
});
